var map = {
	"./arrow-right.svg": 8900,
	"./calendar.svg": 8722,
	"./caret-down-fill.svg": 7751,
	"./caret-down.svg": 8127,
	"./cc-logo.svg": 2566,
	"./chevron-down-black.svg": 8391,
	"./chevron-down.svg": 3362,
	"./close-icon.svg": 1297,
	"./default-news.png": 4281,
	"./emblem.svg": 2758,
	"./envelope-contacts.svg": 1532,
	"./envelope.svg": 5889,
	"./f-blue.svg": 2515,
	"./f-white.svg": 6749,
	"./f.svg": 433,
	"./facebook.svg": 5925,
	"./feedback-success.svg": 5345,
	"./filter-square.svg": 2797,
	"./gerb.svg": 1555,
	"./house-door.svg": 3841,
	"./instagram.svg": 7927,
	"./list-check.svg": 1690,
	"./mclaut_logo.png": 6737,
	"./megaphone.svg": 8639,
	"./next-page.svg": 5769,
	"./people.svg": 2477,
	"./previous-page.svg": 4381,
	"./search.svg": 3655,
	"./social/manager/facebook.svg": 7655,
	"./social/manager/instagram.svg": 9818,
	"./social/manager/telegram.svg": 411,
	"./social/manager/viber.svg": 4966,
	"./stopwatch.svg": 3513,
	"./telephone-inbound-contacts.svg": 7546,
	"./telephone-inbound-dark.svg": 5499,
	"./telephone-inbound.svg": 5078,
	"./tropical-storm.svg": 4653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;